import { useState, useEffect } from 'react';

const ListeningDots = () => {
  const [dots, setDots] = useState('');

  useEffect(() => {
    const interval = setInterval(() => {
      setDots(prevDots => {
        if (prevDots.length >= 3) return '';
        return prevDots + '.';
      });
    }, 500);

    return () => clearInterval(interval);
  }, []);

  return (
    <div className="flex items-center justify-center p-4">
      <span className="text-xl font-bold text-gray-700">
        I'm listening{dots}
      </span>
    </div>
  );
};

export default ListeningDots;